export enum ConcretingMessages {
  todayText = "concreting.todayText",
  pastText = "concreting.pastText",
  futureText = "concreting.futureText",
  trackDelivery = "concreting.trackDelivery"
}

export interface TranslationConcretingMessages {
  [ConcretingMessages.todayText]: string;
  [ConcretingMessages.pastText]: string;
  [ConcretingMessages.futureText]: string;
  [ConcretingMessages.trackDelivery]: string;
}
